import { useEffect, useState } from "react";
import type { CuttlefishConnection } from "../types";
import type { WebRTCHealthSnapshot } from "../lib/healthMonitor";

/**
 * Subscribe to the connection's WebRTC health snapshots.
 * Returns the latest snapshot, or null when there is no connection
 * (or the connection does not implement health reporting).
 */
export function useCuttlefishHealth(
  connection?: CuttlefishConnection | null,
): WebRTCHealthSnapshot | null {
  const [snapshot, setSnapshot] = useState<WebRTCHealthSnapshot | null>(
    () => connection?.getHealthSnapshot?.() ?? null,
  );

  useEffect(() => {
    if (!connection) {
      setSnapshot(null);
      return;
    }
    setSnapshot(connection.getHealthSnapshot?.() ?? null);
    return connection.onHealth?.(setSnapshot);
  }, [connection]);

  return snapshot;
}
